/*
 * @Author: Ashley.Liu
 * @Date: 2022-03-14 13:36:10
 * @LastEditTime: 2022-07-06 17:56:39
 * @Description: desc
 */
export function isEmpty (obj) {
  try {
      if (obj === null || obj === undefined) {
          return true
      }
      if (typeof obj === 'number') {
          if (isNaN(obj)) {
              return true
          } else {
              return false
          }
      }
      if (typeof obj === 'boolean' || typeof obj === 'function' || obj instanceof Date || obj instanceof RegExp) {
          return false
      }
      if (typeof obj === 'string') {
          if (obj.trim().length === 0) {
              return true
          } else {
              return false
          }
      }

      if (typeof obj === 'object') {
          if (obj instanceof Array) {
              if (obj.length === 0) {
                  return true
              } else {
                  return false
              }
          }

          if (obj instanceof Object) {
              if (Object.getOwnPropertyNames(obj).length === 0) {
                  return true
              } else {
                  return false
              }
          }
      }
  } catch (e) {
      console.log(e)
      return false
  }
}
